// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1blRO","alertIcon":"ConfirmModal_alertIcon__19GBR"};